<template>
  <BaseCard :heading="filters.capitalize($t('global.items.service', 2))">
    <Flex direction="column">
      <Flex
        direction="column"
        :gap="0.5"
      >
        <Part
          v-for="row in groupedParts"
          :key="row.key"
          :parts="row.parts"
          :servicePackage="row.servicePackage"
          v-test="'appointment-part'"
        />
      </Flex>
      <Flex
        v-if="endBuffer"
        fullWidth
        justify="between"
        align="center"
        v-test="'appointment-end-buffer'"
      >
        <BaseText bold>
          {{ $t('appointment.features.end_buffer') }}
        </BaseText>
        <BaseText iconBefore="clock">
          {{ `${endBuffer} ${$t('global.minute_short')}` }}
        </BaseText>
      </Flex>
    </Flex>
  </BaseCard>
</template>

<script
  lang="ts"
  setup
>
import filters from '@/filters';
import { groupParts } from '@/modules/calendar/appointment/appointment-parts/part-rows';
import { useServicesStore } from '@/stores/services';
import Part from './Part.vue';

const props = defineProps<{
  data: any[];
  endBuffer?: number;
}>();

const { servicePackageByServicePackageServiceId } = useServicesStore();

const groupedParts = computed(() =>
  groupParts(props.data, (part) =>
    servicePackageByServicePackageServiceId(part.servicePackageServiceId),
  ).map((row) => ({
    key: row.key,
    parts: row.partIndexes.map((partIndex) => props.data[partIndex]),
    servicePackage: row.kind === 'package' ? row.servicePackage : undefined,
  })),
);
</script>
